<template>
  <a-modal
    title="分组"
    :visible="visible"
    :width="800"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleVisible"
    style="height: 500px"
  >
    <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="分组">
        <a-select v-model="groupId">
          <a-select-option v-for="item in groupList" :key="item.id">
            {{ item.groupName }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import {
  getGroupList,
  addProductToGroup,
  batchBindProductToGroup,
} from '@/api/product';
export default {
  data() {
    return {
      visible: false,
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 5,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      groupList: [],
      fundCode: '',
      groupId: '',
      isBath: false,
    };
  },
  created() {},
  methods: {
    handleVisible() {
      this.visible = !this.visible;
    },
    handleOk() {
      let that = this;
      let params = {
        fundCodeList: that.fundCode,
        fundGroupId: that.groupId,
      };
      if (!this.isBath) {
        addProductToGroup(params).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            this.visible = false;
            this.$emit('callback');
          } else {
            that.$message.error(res.message);
          }
        });
      } else {
        batchBindProductToGroup(params).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            this.visible = false;
            this.groupId = '';
            this.$emit('callback');
          } else {
            that.$message.error(res.message);
          }
        });
      }
    },
    initGroupList(id) {
      if (typeof id == 'string') {
        this.fundCode = [id];
        this.isBath = false;
      } else {
        this.fundCode = id;
        this.isBath = true;
      }
      let that = this;
      getGroupList().then((res) => {
        if (res.success) {
          that.groupList =
            res.result && res.result.records ? res.result.records : [];
        } else {
          that.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style scoped></style>
